import React from "react";
import {
  Container,
  makeStyles,
  Paper,
  Box,
  Typography,
  Button,
} from "@material-ui/core";
import Page from "src/components/Page";
import AccessibilityDecl from "src/components/common/AccessibilityDecl";
import AccessibilityDeclFedp from "src/components/common/AccessibilityDeclFedp";
import { NavLink as RouterLink } from "react-router-dom";
import { FileIcon, defaultStyles } from "react-file-icon";
import SvgIcon from "@material-ui/core/SvgIcon";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { apiDownloadFileData, apiEndpoints } from "src/utils/api/api";
import fileDownload from "js-file-download";
import { connect } from "react-redux";
import { getSystemLabel } from "src/constant/Messages";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  massagebox: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  lcontent: {
    fontSize: 11,
  },
  img: {
    margin: "auto",
    display: "block",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "42%",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "52%",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95%",
    },
    maxHeight: "100%",
  },
}));

const AccessibilityDeclaration = ({ globalData }) => {
  const classes = useStyles();

  const accDeclFileName = `Deklaracja dostępności systemu portalu KM ${getSystemLabel(
    "programShortcut",
    globalData.systemInfo
  )}.docx`;

  const handleFileDownload = (documentKey, fileName) => {
    apiDownloadFileData(
      `${apiEndpoints.downloadSystemDocument.path}${documentKey}`,
      true
    )
      .then((result) => {
        fileDownload(result, fileName);
      })
      .catch((error) => {});
  };

  return (
    <Page className={classes.root} title="Deklaracja dostępności">
      <Container maxWidth="lg">
        <Box
          display="flex"
          flexDirection="column"
          height="100%"
          justifyContent="center"
        >
          <Box mb={1}>
            <Paper>
              <Box p={2}>
                <Typography
                  color="textPrimary"
                  component="h1"
                  variant="h2"
                  align="center"
                  paragraph id="a11y-deklaracja"
                >
                  Deklaracja dostępności
                </Typography>
                {globalData.systemInfo.fundProgram == "fedp2127" ? (
                  <AccessibilityDeclFedp></AccessibilityDeclFedp>
                ) : (
                  <AccessibilityDecl></AccessibilityDecl>
                )}
                <Box p={2} display="flex" flexWrap="wrap">
                  <Box p={1}>
                    <SvgIcon className={classes.fileicon}>
                      <FileIcon extension={"docx"} {...defaultStyles["docx"]} />
                    </SvgIcon>
                    <Typography className={classes.filename} display="inline">
                      {accDeclFileName}
                    </Typography>
                  </Box>

                  <Box ml={2} p={1}>
                    <Button
                      title={`Pobranie Deklaracji dostępności systemu portalu KM ${getSystemLabel(
                        "programShortcut",
                        globalData.systemInfo
                      )} w formie pliku DOCX`}
                      aria-label={`Pobranie Deklaracji dostępności systemu portalu KM ${getSystemLabel(
                        "programShortcut",
                        globalData.systemInfo
                      )} w formie pliku DOCX`}
                      variant="contained"
                      color="default"
                      className={classes.button}
                      startIcon={<CloudDownloadIcon />}
                      onClick={() =>
                        handleFileDownload(
                          "accessibility_declaration",
                          accDeclFileName
                        )
                      }
                    >
                      Pobierz plik
                    </Button>
                  </Box>
                </Box>
              </Box>
              <Box p={2}>
                <Button
                  color="primary"
                  className={classes.button}
                  component={RouterLink}
                  to={`/logowanie`}
                >
                  Powrót
                </Button>
              </Box>
            </Paper>
          </Box>
        </Box>
      </Container>
      <Box display="flex" alignItems="flex-end" flexGrow={1} p={1}>
        <Box display="flex" flexDirection="column">
          <img
            className={classes.img}
            alt="Logo UE stopka"
            src="/static/images/logo_ue_main.jpg"
          />
          <Typography
            variant="caption"
            gutterBottom
            color="textSecondary"
            align="center"
            component="p"
          >
            Aplikacja współfinansowana przez Unię Europejską ze środków
            Europejskiego Funduszu Społecznego w ramach Regionalnego Programu
            Operacyjnego Województwa Podlaskiego na lata 2014-2020
          </Typography>
          <Typography
            color="textPrimary"
            variant="subtitle2"
            align="center"
            component="p"
          >
            2021 © Urząd Marszałkowski Województwa Podlaskiego
          </Typography>
        </Box>
      </Box>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

export default connect(mapStateToProps, null)(AccessibilityDeclaration);
